import React from "react";

const PdfFullView = ({ fileUrl }) => {
    return (
        <iframe
            src={fileUrl}
            title="PDF Viewer"
            style={{
                width: "100vw",
                height: "100vh",
                border: "none",
            }}
        />
    );
};

export default PdfFullView;
